import { __extends } from "tslib";
import React from "react";
import { Text, View } from "react-native";
import moment from "moment";
import PropTypes from "prop-types";
import styles from "./PnmacTime.styles.js";
var PnmacTime = /** @class */function (_super) {
  __extends(PnmacTime, _super);
  function PnmacTime() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacTime.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles[this.props.position].container, this.props.containerStyle[this.props.position]],
      testID: "time"
    }, /*#__PURE__*/React.createElement(Text, {
      style: [styles[this.props.position].text, this.props.textStyle[this.props.position]]
    }, moment(this.props.currentMessage.createdAt).locale(this.context.getLocale ? this.context.getLocale() : "en").format("LT")));
  };
  return PnmacTime;
}(React.Component);
PnmacTime.contextTypes = {
  getLocale: PropTypes.func
};
PnmacTime.defaultProps = {
  position: "left",
  currentMessage: {
    createdAt: null
  },
  containerStyle: {},
  textStyle: {}
};
PnmacTime.propTypes = {
  position: PropTypes.oneOf(["left", "right"]),
  currentMessage: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
  }),
  textStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
  })
};
export default PnmacTime;